module.exports = __webpack_public_path__ + "img/scroll9.9887192e.png";